import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const CancelDriverTrip = ({
  isOpen,
  onClose,
  onConfirm,
  trip,
}) => {
  const route = trip
    ? `${trip.origin || "N/A"} → ${
        trip.destination || "N/A"
      }`
    : "this trip";

  const bodyMessage = `
    Are you sure you want to cancel the trip
    <strong>${route}</strong>?
    This action cannot be undone.
  `;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Cancel Trip"
      bodyMessage={
        <div
          dangerouslySetInnerHTML={{
            __html: bodyMessage,
          }}
        />
      }
      confirmLabel="Confirm"
      cancelLabel="Go Back"
    />
  );
};

export default CancelDriverTrip;